import { protectedService } from "@services/authentication/protected"
import { Navigate } from "react-router"
import { useState, useEffect } from "react"

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null)

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        await protectedService()
        setIsAuthenticated(true)
      } catch (error) {
        setIsAuthenticated(false)
      }
    }
    verifyAuth()
  }, [])

  if (isAuthenticated === null) {
    return null // or <LoadingSpinner />
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in?onboarding=true" replace />
  }

  return children
}

export default ProtectedRoute
